import React, { Component } from 'react';
import { without, contains, append } from 'ramda';
import { withState } from 'recompose';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import CourseListTable from './CourseListTable';

@withState('selected', 'setSelected', [])
@withRouteOptions
export default class CourseListView extends Component {
    static routeOptions = {
        title: 'menu.courses'
    }

    onSelect = (value) => {
        const { selected, setSelected } = this.props;

        if (contains(value, selected)) {
            setSelected(without([value], selected));
        } else {
            setSelected(append(value, selected));
        }
    }

    render() {
        return <CourseListTable
            {...this.props}
            onSelect={this.onSelect}
        />;
    }
}
